import request from '@/utils/request'

// 红寺堡乡镇及养殖场信息组织树 
const videoRegionTree = (params) => {
    return request({
        url: '/api/farm/video/center/region/tree',
        method: 'get',
        params
    })
}
//摄像头列表
const videoCameraList = (farmId) => {
    return request({
        url: `/api/farm/camera/list/${farmId}`,
        method: 'get'
    })
}

//根据养殖场id查看存栏量趋势
const videoExistTrend = (farmId) => {
    return request({
        url: `/api/farm/video/center/exist/trend/${farmId}`,
        method: 'get'
    })
}
export default {
    videoRegionTree,
    videoCameraList,
    videoExistTrend
}